/**
 * Scroll behavior that honors `prefers-reduced-motion`.
 *
 * CSS `scroll-behavior` and the reduced-motion media query only govern
 * scrolling the browser drives (anchor jumps). `scrollTo`/`scrollIntoView`
 * with `behavior: 'smooth'` animate regardless, so every script-driven scroll
 * asks here instead of hardcoding `'smooth'`.
 *
 * Reads the media query at call time, so it works in non-component code and
 * tracks a preference change without a re-render. On the server (no `window`)
 * it returns `'smooth'`; scrolling never happens there anyway.
 *
 * @example
 * window.scrollTo({ top: 0, behavior: scrollBehavior() });
 * element.scrollIntoView({ behavior: scrollBehavior(), block: 'start' });
 */
export function scrollBehavior(): ScrollBehavior {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return 'smooth';
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}
